/**
 * Content settings API client (BFF: `/api/v1/store/settings/content`).
 */
import { apiClient } from '@/shared/api';
import type { ContentSettings, UpdateContentSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/content';

export const getContentSettings = async (): Promise<ContentSettings> =>
  (await apiClient.get<ContentSettings>(BASE)).data;

export const updateContentSettings = async (
  body: UpdateContentSettingsRequest,
): Promise<ContentSettings> => (await apiClient.put<ContentSettings>(BASE, body)).data;
